import DispositionScenario, { IDispositionScenarioSessionProps } from "./DispositionScenario";

/** Supplies the current scenario which should be applied to the disposition step. */
class DispositionScenarioController {
  /** The list of scenarios which might be applied to the Disposition step. */
  private scenarios: DispositionScenario[];

  constructor(scenarios: DispositionScenario[]) {
    this.scenarios = scenarios;
  }

  /** Get the currently applicable scenario from the controller given the current scenario session props.
   * @remarks Retrieves the applicable scenario by iterating through the configured list from start to finish. The
   * first scenario evaluation to satisfy its configured constraint is returned, so logical order of precedence from
   * most limiting to least limiting should be exercised when ordering the scenarios list configuration.
   */
  getScenario = (props: IDispositionScenarioSessionProps): DispositionScenario => {
    const scenario = this.scenarios.find(s => s.constraint(props));
    if (!scenario)
      throw "A scenario must always be applicable to the disposition step. A default should be added to the configuration to prevent this.";
    return scenario;
  };
}

export default DispositionScenarioController;
